export default "__VITE_ASSET__BxUfkAvH__"